import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-preloader',
  styleUrl: './preloader.component.scss',
  templateUrl: './preloader.component.html',
  imports: [],
})
export class PreloaderComponent {}
